import angular from "angular";

module.exports = angular
  .module("market.controllers.humans", [])
  .controller("humans.passwords.edit", function ($scope, Segment) {
    const root = document.querySelector(
      "[ng-controller='humans.passwords.edit']"
    );
    const canReset = !!root && root.getAttribute("data-can-reset") === "true";
    const pageName = canReset
      ? "new-password"
      : "expired-password-token";

    // Track the page view
    Segment.page("reset-password", pageName);
    Segment.track("page-view", {
      path: location.pathname.slice(1),
      pathname: location.pathname,
      resource: "web",
      domain: location.host,
    });

    // Track if the user submitted the form and was redirected back to this
    // page with an error
    const errorContainer = !!root && root.querySelector(".error-message");
    const errorMessage = !!errorContainer && errorContainer.innerHTML;
    if (errorMessage) {
      Segment.track("reset-password", { errorMessage });
    }

    // Track requests for a new reset-password link
    $scope.trackRequestNewLink = function () {
      Segment.track("reset-password", { action: "request new link" });
    };

    // Track new password form submissions
    $scope.trackSubmitNewPassword = function () {
      Segment.track("reset-password", { action: "submit new password" });
    };
  }).name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/controllers/humans.js
 **/